import React, { useState } from "react";
import { Modal } from "antd";
import ApplicationStatusBody from "../Components/ApplicationStatusBody";

const ApplicationStatus = ({ applicationStatus, editApplicationForm, retryApplication, partner, phoneNumber }) => {
    const [isModalVisible, setIsModalVisible] = useState(true);
  
    React.useEffect(() => {
      if (applicationStatus) {
        setIsModalVisible(true);
      }
    }, [applicationStatus]);
  
    return (
      <Modal
        title=""
        visible={isModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <ApplicationStatusBody applicationStatus={applicationStatus} editApplicationForm={editApplicationForm} retryApplication={retryApplication} partner={partner} phoneNumber={phoneNumber} />
      </Modal>
    );
  };

  export default ApplicationStatus;
